/** Config Loader */
export abstract class ConfigLoader {
    /**
     * Load settings
     */
    abstract load(): Promise<any>;
}

/** Config Static Loader */
export class ConfigStaticLoader implements ConfigLoader {
    /**
     * Constructor
     *
     * @param providedSettings
     */
    constructor(private readonly providedSettings?: any) {}

    /**
     * Load settings
     */
    async load(): Promise<any> {
        if (typeof this.providedSettings?.then === 'function') {
            return Promise.resolve(JSON.parse(await this.providedSettings));
        } else {
            return Promise.resolve(this.providedSettings);
        }
    }
}
